import React from 'react';
import NextError from 'next/error';
import { sentryDnsKey } from '../constants';

class Error extends NextError {
  static async getInitialProps(ctx) {
    const { err, isServer } = ctx;
    if (isServer && err) {
      Sentry.init({
        dsn: sentryDnsKey,
        environment: process.env.NODE_ENV,
        ignoreErrors: [
          /OpenYoloError.*/,
          'The prompt() method must be called with a user gesture',
        ],
      });
      Sentry.captureException(err);
    }
    const errorInitialProps = await NextError.getInitialProps(ctx);
    return errorInitialProps;
  }
}

export default Error;



// WEBPACK FOOTER //
// ./pages/_error.js